import { useMemo } from "react";
import { News } from "@/components/widgets/News";
import { EventEmitter } from "@/shared/eventEmiters/EventEmitter";
import { componentClassNames } from "../../../config";
import { useNewsState } from "../../../lib/hooks";
import { LineHeader } from "../LineHeader";

export const QuoteNews = ({
	ticker,
	tileId,
}: {
	ticker: string;
	tileId: string;
}) => {
	const newsState = useNewsState(ticker);

	const quoteNewsEventEmitter = useMemo(() => new EventEmitter(), []);

	return (
		<div className={componentClassNames} data-testid="quote-news">
			<div data-markets-news className="h-full">
				<News
					state={newsState}
					eventEmitter={quoteNewsEventEmitter}
					tileId={`${tileId}-news-grid`}
					className="h-[192px]"
					header={<LineHeader title="Latest News" />}
				/>
			</div>
		</div>
	);
};
